import React from 'react';
import NumberFormat from 'react-number-format';
import { Field } from 'formik';

export default ({
  name,
  placeholder,
  showErrorMessages = true,
  format,
  fieldType,
  maxLength,
  quantityVal,
  onChangeHandler,
  floating = true,
  displayType,
  thousandSeparator,
  decimalScale,
  decimalLimit,
  decimalSeparator,
  fixedDecimalScale,
  allowedDecimalSeparators,
  disabled,
  prefix,
  suffix,
  callBackFlag,
  callBackFun,
  mask,
  quantityLotsMaxValue,
  maxAllowedValueLimit,
  maxQuantity
}) => {
  if (maxLength === undefined) {
    maxLength = 12
  }

  const MAX_VAL = 4000;
  const withValueLimit = (inputObj, name) => {
    const { value } = inputObj;
    if (value >= 0 && value <= MAX_VAL) return true;

    return false;
  };

  const valueLimitHundred = (inputObj, name) => {
    const { value } = inputObj;
    if (value >= 0 && value <= 400) return true;

    return false;
  };
  const quantityLotsHundred = (inputObj, name) => {
    const { value } = inputObj;
    if (value >= 0 && value <= quantityLotsMaxValue) return true;

    return false;
  };
  const lotsInput = (inputObj, name) => {
    const { value } = inputObj;
    if (value >= 0 && value <= 10) return true;

    return false;
  };
  const quantityInput = (inputObj, name) => {
    const { value } = inputObj;
    if (value >= 0 && value <= quantityVal) return true;

    return false;
  };
  const maxQuantityValue = (inputObj, name) => {
    const { value } = inputObj;
    if (value >= 0 && value <= maxQuantity) return true;

    return false;
  };

  const valueLimitMonth = (inputObj, name) => {
    const { value } = inputObj;
    if (value >= 0 && value <= 12) return true;

    return false;
  };

  const commissionValue = (inputObj, name) => {
    const { value } = inputObj;

    if (value >= "99.") {
      return true
    }
    if (value >= 0 && value <= 99) return true;

    return false;
  };


  const withValue = (inputObj) => {
    const { value, floatValue } = inputObj;
    if (name === "endAfterOccurrences") {
      if (value >= 0 && value <= 10) return true;
    } else if (name === 'adminClaimQuality' || name === 'adminClaimQuantity' || name === 'paymentTerm' || name === 'length' || name === 'width' || name === 'height' || fieldType === 'percentage') {
      if (value === '' || !maxAllowedValueLimit) return true;
      if (floatValue > maxAllowedValueLimit) return false;
      if (decimalLimit !== undefined) {
        const decimalPart = value.toString().split('.')[1];
        if (decimalPart && decimalPart.length > decimalLimit) {
          return false;
        }
      }
      return true;
    } else {
      return true;
    }
  };

  return (
    <Field name={name}>
      {({ field, form, meta }) => (
        <div className='app-input-text number-format-input-styles'>
          <NumberFormat
            name={field.name}
            className={`${meta.touched && meta.error ? 'error' : ''}`}
            autoComplete="off"
            prefix={prefix}
            suffix={suffix}
            placeholder={placeholder}
            format={format}
            fixedDecimalScale={fixedDecimalScale}
            decimalScale={decimalScale}
            displayType={displayType}
            disabled={disabled}
            allowNegative={false}
            thousandSeparator={thousandSeparator}
            allowedDecimalSeparators={allowedDecimalSeparators}
            maxLength={maxLength}
            mask={mask}
            isAllowed={name === "pickupMiles" || name === "distanceWillingToTravel" ? withValueLimit :
              name === "basePrice" || name === "desiredPrice" || name === "cpuPrice" || name === 'bidPrice' || name === 'offerPrice' || name === 'offerAmount' ? valueLimitHundred :
                name === "expMonth" ? valueLimitMonth :
                  (name === "lotsEdit" || name === 'quantityGetQuote' || name === 'quantityPerLot' || name === 'offerQty' || name === 'editRecuurenceQty') ? quantityLotsHundred :
                    name === "quantity" ? quantityInput :
                      name === "lots" ? lotsInput :
                        name === "commissionValue" && !prefix ? commissionValue : maxQuantity ? maxQuantityValue : withValue}
            onValueChange={(e) => {
              if (onChangeHandler !== undefined)
                onChangeHandler(e.value)

              if (name === "endAfterOccurrences" || callBackFlag) callBackFun(e.value)
            }}
            {...field}
            onBlur={(e) => {
              // if user typed something and it doesn't contain a decimal, add ".0" or based on decimalLimit
              if (fieldType === 'percentage' && decimalLimit && decimalLimit > 0) {
                let val = e.target.value;                
                if (val && !val.includes('.')) {
                  let paddedVal = val + '.' + '0'.repeat(decimalLimit);
                  form.setFieldValue(name, paddedVal);
                }
              }
              field.onBlur(e);
            }}
          />
          {meta.touched && meta.error && showErrorMessages && (
            <p name={name + 'Error'} className='error-message'>{meta.error}</p>
          )}
        </div>
      )}
    </Field>
  );
}
